module.exports = __webpack_public_path__ + "static/media/mern-logo.8967ca67.png";